module.exports = __webpack_public_path__ + "img/ruqin.b5e254d0.svg";